import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleModal } from "../../features/assignments/assignmentSlice";

const Modal = ({ height = "280px", width = "700px", children }) => {
  //   const [showModal, setShowModal] = useState(true);
  const dispatch = useDispatch();
  const { showModal } = useSelector((state) => state.assignments);

  const modalRef = React.useRef(null);

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
    //   setShowModal(false);
      dispatch(toggleModal(false));
    }
  };
  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) {
        // setShowModal(false);
        dispatch(toggleModal(false));
      }
    },
    [dispatch, showModal]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);
  return (
    <>
      {showModal && (
        <div className="popup" ref={modalRef} onClick={closeModal}>
          <div
            className="popup__container"
            style={{ height: height, width: width }}
          >
            <div className="popup__close__icon">
              <span onClick={() => dispatch(toggleModal(false))}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.84375 7L12.8438 3C12.9062 2.9375 12.9531 2.86458 12.9844 2.78125C13.026 2.69792 13.0469 2.60417 13.0469 2.5C13.0469 2.40625 13.026 2.31771 12.9844 2.23438C12.9531 2.15104 12.9062 2.07812 12.8438 2.01562L11.9844 1.15625C11.9219 1.09375 11.8438 1.04688 11.75 1.01562C11.6667 0.973958 11.5781 0.953125 11.4844 0.953125C11.3906 0.953125 11.3021 0.973958 11.2188 1.01562C11.1354 1.04688 11.0625 1.09375 11 1.15625L7 5.15625L3 1.15625C2.9375 1.09375 2.85938 1.04688 2.76562 1.01562C2.68229 0.973958 2.59375 0.953125 2.5 0.953125C2.40625 0.953125 2.31771 0.973958 2.23438 1.01562C2.15104 1.04688 2.07812 1.09375 2.01562 1.15625L1.15625 2.01562C1.09375 2.07812 1.04167 2.15104 1 2.23438C0.96875 2.31771 0.953125 2.41146 0.953125 2.51562C0.953125 2.60938 0.96875 2.69792 1 2.78125C1.04167 2.86458 1.09375 2.9375 1.15625 3L5.15625 7L1.15625 11C1.09375 11.0625 1.04167 11.1354 1 11.2188C0.96875 11.3021 0.953125 11.3958 0.953125 11.5C0.953125 11.5938 0.96875 11.6823 1 11.7656C1.04167 11.849 1.09375 11.9219 1.15625 11.9844L2.01562 12.8438C2.07812 12.9062 2.15104 12.9583 2.23438 13C2.32812 13.0312 2.42188 13.0469 2.51562 13.0469C2.60938 13.0469 2.69792 13.0312 2.78125 13C2.875 12.9583 2.95312 12.9062 3.01562 12.8438L7.01562 8.84375L11.0156 12.8438C11.0781 12.9062 11.151 12.9583 11.2344 13C11.3177 13.0312 11.4062 13.0469 11.5 13.0469C11.6042 13.0469 11.6979 13.0312 11.7812 13C11.8646 12.9583 11.9375 12.9062 12 12.8438L12.8594 11.9844C12.9219 11.9219 12.9688 11.849 13 11.7656C13.0417 11.6823 13.0625 11.5885 13.0625 11.4844C13.0625 11.3906 13.0417 11.3021 13 11.2188C12.9688 11.1354 12.9219 11.0625 12.8594 11L8.84375 7Z"
                    fill="#555555"
                  />
                </svg>
              </span>
            </div>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
